// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.viewed[data-v-04f0bc98] {\n  background-color: #f2f2f2;\n}\n", ""]);
// Exports
module.exports = exports;
